<template>
    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
            <div class="d-block row col-lg-8 mx-auto">
                <label style="line-height:1.5">Check one of the following and list all that apply to the relationship
                    between you and the vendor. </label>
                <OmniSelect placeholder="Select Relationship" name="Media" :showLabel="false" label="Select Media"
                    :options="RelationshipVendors" v-model="MediaVendor.EmployeeVendorRelationship" />
            </div>
            <div class="d-block row col-lg-8 mx-auto mt-2" v-for="VendorRelation in MediaVendor.EmployeeVendorRelationship"
                :key="VendorRelation">
                <span v-if="!IsNoneSelected">
                    <label>{{ GetRelationshipLabel(VendorRelation) }}</label>
                    <b-form-input @focus="ResetDirty(VendorRelation)" @blur="SetDirty(VendorRelation)" autocomplete="off"
                        class="omniipclass" v-model="MediaVendor.EmployeeVendorRelationshipDetails[VendorRelation]"
                        :placeholder="GetRelationshipLabel(VendorRelation)" :maxlength="100"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.EmployeeVendorRelationshipDetails[VendorRelation].$dirty && !$v.MediaVendor.EmployeeVendorRelationshipDetails[VendorRelation].required">
                        Required field
                    </div>
                </span>
            </div>
            <div class="d-block row col-lg-8 mx-auto mt-3">
                <b-form-group
                    label="Has any form of compensation or gifts of any type been offered to you or any person related to you in exchange for placing an order with this vendor?">
                    <b-form-radio-group id="credit-card" v-model="MediaVendor.AnyGiftOrCompensationOfferedToYouToPlaceOrder"
                        name="credit-card">
                        <b-form-radio value="true">Yes</b-form-radio>
                        <b-form-radio value="false">No</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="d-block row col-lg-10 offset-lg-2" v-if="CompensationReceived">
                <b-form-group>
                    <label class="pb-2">Compensation Received</label>
                    <div class="fieldborder" >
                        <b-form-input autocomplete="off" id="compensation-dollar" class="form-control col-md-3"
                            placeholder="Compensation" v-model="MediaVendor.CompensationReceived" :maxLength="6"
                            @blur="formatDollars()"></b-form-input>
                        <div v-show="!IsCompensationDollarsValid" class="error-messages">
                            This field can only contain numerical values
                        </div>
                    </div>
                </b-form-group>
            </div>
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button v-if="IsDraftVisible" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
                SAVE FOR LATER
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
                BACK
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>

    </div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import {
    required,
    requiredIf
} from 'vuelidate/lib/validators';
import mediaVendorSaveAsDraft from '../../../mixins/mediaVendorSaveAsDraft';
export default {
  mixins: [mediaVendorSaveAsDraft],
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            // MediaVendor: {
            //     EmployeeVendorRelationship: [],
            //     FormerEmployee: null,
            //     CompensationOrGiftProvided: null
            // },
            RelationshipVendors: [{
                "label": "NONE",
                value: "NONE"
            },
            {
                "label": "Former Employee (name) ",
                value: "FormerEmployeeName"
            },
            {
                "label": "Family Member(name)",
                value: "FamilyMemberName"
            },
            {
                "label": "Friend (name)",
                value: "FriendName"
            },
            {
                "label": "Vendor has a relationship w/ Agency Client",
                value: "VendorRelationshipWithAgencyClient"
            },
            {
                "label": "Vendor of Former employee",
                value: "VendorOfFormerEmployee"
            },
            {
                "label": "Vendor was former employee of Agency",
                value: "VendorWasFormerEmployeeOfAgency"
            },
            {
                "label": "Vendor has a relationship w/ another Agency employee (list employee name)",
                value: "VendorHasRelationshipWithAnotherAgencyEmployee"
            },
            {
                "label": "Other",
                value: "Other"
            }
            ],
            RelationshipVendorsLabel: [{
                "label": "NONE",
                value: "NONE"
            },
            {
                "label": "Former Employee's Name",
                value: "FormerEmployeeName"
            },
            {
                "label": "Family Member's Name",
                value: "FamilyMemberName"
            },
            {
                "label": "Friend's Name",
                value: "FriendName"
            },
            {
                "label": "Explain the nature of the relationship",
                value: "VendorRelationshipWithAgencyClient"
            },
            {
                "label": "Former Employee Name",
                value: "VendorOfFormerEmployee"
            },
            {
                "label": "Former Employee’s Name of Agency",
                value: "VendorWasFormerEmployeeOfAgency"
            },
            {
                "label": "Name of employee with another Agency",
                value: "VendorHasRelationshipWithAnotherAgencyEmployee"
            },
            {
                "label": "Other",
                value: "Other"
            }
            ]
        }
    },
    validations: {
        MediaVendor: {
            AnyGiftOrCompensationOfferedToYouToPlaceOrder: {
                required: required
            },
            CompensationReceived: {
                required: requiredIf(function (model) {
                    return model.AnyGiftOrCompensationOfferedToYouToPlaceOrder == "true";
                })
            },
            EmployeeVendorRelationship: {
                required: required
            },
            EmployeeVendorRelationshipDetails: {
                FormerEmployeeName: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('FormerEmployeeName')
                    })
                },
                FamilyMemberName: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('FamilyMemberName')
                    })
                },
                FriendName: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('FriendName')
                    })
                },
                VendorRelationshipWithAgencyClient: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('VendorRelationshipWithAgencyClient')
                    })
                },
                VendorOfFormerEmployee: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('VendorOfFormerEmployee')
                    })
                },
                VendorWasFormerEmployeeOfAgency: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('VendorWasFormerEmployeeOfAgency')
                    })
                },
                VendorHasRelationshipWithAnotherAgencyEmployee: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('VendorHasRelationshipWithAnotherAgencyEmployee')
                    })
                },
                Other: {
                    required: requiredIf(function () {
                        return this.MediaVendor.EmployeeVendorRelationship.includes('Other')
                    })
                }
            }

        }
    },
    computed: {
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        CompensationReceived() {
            return this.MediaVendor.AnyGiftOrCompensationOfferedToYouToPlaceOrder == "true";
        },
        IsNoneSelected() {
            return this.MediaVendor.EmployeeVendorRelationship.findIndex(val => val == "NONE") > -1;
        },
        ...mapGetters('mediavendor', {
            MediaVendor: 'MediaVendor',
        }),
        IsDraftVisible() {
            return this.id == null || this.id == 0 || this.isDraft == true;
        },
    },
    watch: {
        "MediaVendor.EmployeeVendorRelationship": function (val) {
            if (val.includes('NONE') && val.length > 1) {
                //val=val.filter(rel=>rel=="NONE");
                var index5 = val.indexOf('NONE');
                if (index5 > -1) {
                    // val.splice(index5, 1);
                    val.splice(0, 0, val.splice(index5, 1)[0]);
                }
                let arraLength = val.length;
                for (var i = 1; i <= arraLength; i++) {
                    val.splice(i, 1);
                }
                this.$set(this.MediaVendor, "AnyGiftOrCompensationOfferedToYouToPlaceOrder", 'false');
            }

        },
        "MediaVendor.AnyGiftOrCompensationOfferedToYouToPlaceOrder": function (val) {
            if (val == false || val == 'false') {
                this.$set(this.MediaVendor, "CompensationReceived", null);
            }
        }
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    mounted() {
        this.formatDollars();
    },
    methods: {
        formatDollars() {
            this.IsCompensationDollarsValid = true;
            if (this.MediaVendor.CompensationReceived && this.MediaVendor.CompensationReceived != '') {
                var num = this.MediaVendor.CompensationReceived.toString().replace(',', '');

                num = Number(num);
                if (!isNaN(num)) {
                    let temp = num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    this.MediaVendor.CompensationReceived = temp;
                }
                else {
                    this.IsCompensationDollarsValid = false;
                    this.MediaVendor.CompensationReceived = '';
                }
            }
        },
        SetDirty(propertyName) {
            this.$v.MediaVendor.EmployeeVendorRelationshipDetails[propertyName].$touch();

        },
        ResetDirty(propertyName) {
            this.$v.MediaVendor.EmployeeVendorRelationshipDetails[propertyName].$reset();
        },
        GetRelationshipLabel(value) {
            let relationsshipIndex = this.RelationshipVendorsLabel.findIndex(val => {
                return val.value == value;
            })
            if (relationsshipIndex > -1) {
                return this.RelationshipVendorsLabel[relationsshipIndex].label;
            } else {
                return "";
            }
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Media Vendor Review",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Media Vendor Review"
                });
            }
        },
        Cancel() {
            this.$router.push("/VendorRequests");
        },
        Previous() {
            if (this.id) {
                this.$router.push({
                    name: "Media Vendor Setup Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Media Vendor Setup Info"
                });
            }
        },
    }
}
</script>

<style>
fieldset.form-group:not(.custom-radio)>legend {
    padding-left: 0px !important;
}

input#compensation-dollar {
    background-image: url("data:image/svg+xml;utf8,<svg \
                                xmlns='http://www.w3.org/2000/svg' \
                                             version='1.1' height='40px' width='40px'>\
                                     <text x='2' y='22' \
                                fill='gray' font-size='15'>$</text></svg>");
    background-repeat: no-repeat;

}
.error-messages {
    font-size: 10px;
    color: red !important;
    font-family: "Open Sans";
    padding-left: 7px;
    padding-top: 5px;
}
</style>
